import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NiveauEtude } from 'src/app/shared/models/niveauEtude';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class NiveauEtudeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllNiveauEtude(): Observable<NiveauEtude[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.niveauEtudeUrl}/all`,
			'getAllNiveauEtude'
		);
	}

	importNiveauEtude(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'niveauEtude.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.niveauEtudeUrl}/import`,
			`importNiveauEtude`,
			formData
		);
	}

	getNiveauEtudeById(id: number): Observable<NiveauEtude> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.niveauEtudeUrl}/get/${id}`,
			'getNiveauEtudeById'
		);
	}

	updateNiveauEtude(niveauEtude: NiveauEtude): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.niveauEtudeUrl}/update/${niveauEtude.id}`,
			'updateNiveauEtude',
			niveauEtude
		);
	}

	addNiveauEtude(niveauEtude: NiveauEtude): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.niveauEtudeUrl}/add`,
			'addNiveauEtude',
			niveauEtude
		);
	}

	deleteNiveauEtude(niveauEtudeId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.niveauEtudeUrl}/delete/${niveauEtudeId}`,
			`deleteNiveauEtude`
		);
	}
}
